import { getAxisInterval } from './../util'

/**
 * @typedef getAppropriateRange
 * @property {number} range
 * @property {number} interval
 *
 * Given an actual value and a target value, returns a range and interval
 * that would display nicely on a bullet chart.
 * @param {number} actualValue
 * @param {number} targetValue
 * @returns {getAppropriateRangeResult}
 */
export const getAppropriateRange = function(actualValue, targetValue) {
  var range
  if (actualValue == null) {
    range = targetValue * 2
  } else {
    range =
      Math.max(actualValue, targetValue) +
      Math.sqrt(Math.pow(targetValue - actualValue, 2))
  }

  var interval = getAxisInterval(range)

  range = interval * Math.ceil(range / interval)

  return { range, interval }
}



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChart/bulletChat_util.js